export default "__VITE_ASSET__CR0aQmWX__"